<div class="card">
  <app-header titulo="Adiantamento" descricao="Dados de adiantamentos"></app-header>

  <p-table [value]="adiantamentos" [(selection)]="adiantamentosSelecionados" dataKey="idPagto" [loading]="processando"
           #dt
           [globalFilterFields]="['idPagto','instancia','cdUpnivel1','cdProcesso','dtPagto','cdItemErp','qtItem','cdFornecPims','cdFornecErp','vlTotal','vlDesconto','vlLiquido','cdCcustoErp','cdContratoPims','cdAprovErp','cdFavorecErp','qtPercFavorec','vlLiquidoFavorec','vlBrutoFavorec','deMensagemInteg','noDocErp']"
           styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
           [rowsPerPageOptions]="[20, 50, 100, 500, 1000]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true"
           currentPageReportTemplate="{{adiantamentosSelecionados.length}} Registros selecionados | Mostrando de {first} até {last} de {totalRecords} registros"
           (onPage)="onPageChange($event)" (onFilter)="onFilter($event)" (selectionChange)="onSelectionChange()">
    <ng-template pTemplate="caption">
      <div class="flex">

        <app-empresa-dropdown [(selecionadas)]="instanciaSelecionada"/>

         <p-multiSelect appendTo="body" [options]="processos" [filter]="true" [style]="{'width':'200px'}" [(ngModel)]="processosSelecionados" placeholder="Processos"
            emptyMessage="Nenhum processo" selectedItemsLabel="Vários Selecionados" (onChange)="getAdiantamentos()">

            <ng-template let-value pTemplate="selectedItems">
                  <div class="inline-flex align-items-center gap-2 px-1" *ngFor="let option of value">
                
                    <div>{{option.codigo}} - {{ option.descricao }},</div>
            </div>
            <div *ngIf="!value || value.length === 0">Selecione o processo</div>
            </ng-template>

            <ng-template let-option pTemplate="item">
                  <div class="inline-block vertical-align-middle">
                    <span class="ml-1 mt-1">{{option.codigo}} - {{ option.descricao }}</span>
                  </div>
                </ng-template>

        </p-multiSelect>
        
        <!-- <p-multiSelect
          appendTo="body"
          [options]="instancias"
          [filter]="true"
          [style]="{'width':'200px'}"
          optionValue="id"
          optionLabel="nome"
          [(ngModel)]="instanciaSelecionada"
          dataKey="id" inputId="id"
          placeholder="Instância"
          emptyMessage="Nenhuma instância"
          (onClose)="getAdiantamentos()">

        </p-multiSelect> -->

        <div class="flex justify-content-center">
          <p-calendar
            [(ngModel)]="rangeDates"
            selectionMode="range"
            dateFormat="dd/mm/yy"
            [readonlyInput]="true"
            (onClose)="getAdiantamentos()" placeholder="Período"/>
        </div>

        <div class="flex justify-content-center">
          <button class="ml-3" pButton (click)="sincronizar()" style="font-size: 1.0rem" [loading]="loadingSincronizar"
                  [disabled]="processando" icon="pi pi-arrow-down-right" label="Buscar PIMS"></button>
          <button class="ml-3" pButton (click)="integrar()" style="font-size: 1.0rem" [loading]="loadingIntegrar"
                  [disabled]="processando" icon="pi pi-arrow-up-right" label="Enviar ERP"></button>
          <button class="ml-3" pButton (click)="exportar()" style="font-size: 1.0rem" [loading]="loadingIntegrar"
                  [disabled]="processando" icon="pi pi-file-excel" label="Exportar"></button>
          <p-splitButton class="ml-3" label="Reversão" icon="pi pi-undo" [model]="itensReversao"/>
        </div>

        
        <!-- <input  class="ml-8" [style]="{'width':'140px'}" pInputText type="text" [(ngModel)]="processo" placeholder="Código processo"> -->
        <span class="p-input-icon-left ml-auto">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')"
                         placeholder="Pesquisar"/>
              </span>
        <button class="ml-3" pButton pRipple icon="pi pi-refresh" (click)="getAdiantamentos()"
                [loading]="processando"></button>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 4rem">
          <p-checkbox [(ngModel)]="selecionados" [binary]="true" (onChange)="selecionarRegistros($event)">
            <ng-template pTemplate="icon">
                    <span>
                     <i *ngIf="iconeCheckbox === 'Nenhum'"
                        class="pi pi-square"></i>
                      <!-- Estado: Parcial -->
                      <i *ngIf="iconeCheckbox === 'Parcial'"
                         class="pi pi-minus"
                         style="color: var(--secondary-color);"></i>
                      <!-- Estado: Todos -->
                      <i *ngIf="iconeCheckbox === 'Todos'"
                         class="pi pi-check"
                         style="color: var(--secondary-color);"></i>
                        </span>
            </ng-template>
          </p-checkbox>
          <span><a style="text-decoration: underline; cursor: pointer" (click)="selectionarTodos()"
                   *ngIf="adiantamentosSelecionados.length >= 1 && adiantamentosSelecionados.length < adiantamentos.length">Tudo?</a></span>
        </th>
        <th>Id Pagto.</th>
        <th>Instância</th>
        <th>Fazenda</th>
        <th>Código Processo</th>
        <th pSortableColumn="fgTpProc">Tipo <p-sortIcon field="fgTpProc" /></th>
        <th>Data Pagamento</th>
        <th>Código Item ERP</th>
        <th>Quantidade item</th>
        <th>Código Fornec. PIMS</th>
        <th>Código Fornec. ERP</th>
        <th>Valor Total</th>
        <th>Valor Desconto</th>
        <th>Valor Líquido</th>
        <th>CCusto ERP</th>
        <th>Código Contrato PIMS</th>
        <th>Código Aprovação ERP</th>
        <th>Código Favorec. ERP</th>
        <th>Quantide Perc. Favorec</th>
        <th>Valor Líquido Favorec</th>
        <th>Valor Bruto Favorec</th>
        <th pSortableColumn="fgStatusInteg">
          Status
          <p-sortIcon field="fgStatusInteg"/>
          <p-columnFilter field="fgStatusInteg" matchMode="in" display="menu" [showApplyButton]="false"
                          [showClearButton]="false" [showMatchModes]="false" [showOperator]="false"
                          [showAddButton]="false">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <p-multiSelect [ngModel]="value" selectedItemsLabel="Vários selecionados" [options]="status"
                             placeholder="Todos" [filter]="true" optionValue="value" (onChange)="filter($event.value)"
                             optionLabel="name">
                <ng-template let-option pTemplate="item">
                  <div class="inline-block vertical-align-middle">
                    <span class="ml-1 mt-1">{{ option.name }}</span>
                  </div>
                </ng-template>
              </p-multiSelect>
            </ng-template>
            <ng-template pTemplate="clearfiltericon">
            </ng-template>
          </p-columnFilter>
        </th>
        <th>Mensagem</th>
        <th>Documento ERP</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-adiantamento>
      <tr>
        <td>
          <p-tableCheckbox [value]="adiantamento"/>
        </td>
        <td>{{ adiantamento.idPagto }}</td>
        <td>{{ adiantamento.instancia }}</td>
        <td>{{ adiantamento.cdUpnivel1 }}</td>
        <td>{{ adiantamento.cdProcesso }}</td>
        <td>{{ adiantamento.fgTpProc }}</td>
        <td>{{ adiantamento.dtPagamento }}</td>
        <td>{{ adiantamento.cdItemErp }}</td>
        <td>{{ adiantamento.qtItem }}</td>
        <td>{{ adiantamento.cdFornecPims }}</td>
        <td>{{ adiantamento.cdFornecErp }}</td>
        <td>{{ adiantamento.vlTotal }}</td>
        <td>{{ adiantamento.vlDesconto }}</td>
        <td>{{ adiantamento.vlLiquido }}</td>
        <td>{{ adiantamento.cdCcustoErp }}</td>
        <td>{{ adiantamento.cdContratoPims }}</td>
        <td>{{ adiantamento.cdAprovErp }}</td>
        <td>{{ adiantamento.cdFavorecErp }}</td>
        <td>{{ adiantamento.qtPercFavorec }}</td>
        <td>{{ adiantamento.vlLiquidoFavorec }}</td>
        <td>{{ adiantamento.vlBrutoFavorec }}</td>
        <td>
          <app-tag-status [status]="adiantamento.fgStatusInteg"></app-tag-status>
        </td>
        <td>{{ adiantamento.deMensagemInteg }}</td>
        <td>{{ adiantamento.noDocErp }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <td colspan="10">Nenhum registro encontrado</td>
    </ng-template>
  </p-table>

  <p-confirmDialog header="Confirmation" width="425"></p-confirmDialog>
</div>
